export function isRichTextElementVariant(
  mark: RichTextVariant,
): mark is RichTextElementVariant {
  return ['paragraph', 'ul', 'ol', 'li', 'blockquote'].includes(mark);
}
